import React from "react";

const AccountDetails = ({ email, name }) => {
  return (
    <>
      {" "}
      <div className=" mt-5">
        <h2 className="text-xl font-semibold mb-4">Account Details</h2>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Name
          </label>
          <p className="text-gray-900">{name}</p>
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Email
          </label>
          <p className="text-gray-900">{email}</p>
        </div>
      </div>
    </>
  );
};

export default AccountDetails;
